dmx.Component('dropzone', {

    extends: 'input',

    initialData: {
        file: null,
        files: []
    },

    attributes: {
        accept: {
            type: String,
            default: ''
        },

        message: {
            type: String,
            default: 'Drop files here or click to upload.'
        },

        'thumbs': {
            type: String,
            default: 'true'
        },

        'thumb-width': {
            type: Number,
            default: 100
        },

        'thumb-height': {
            type: Number,
            default: 100
        }
    },

    methods: {
        remove: function(id) {
            this.remove(id);
        },

        reset: function() {
            this.reset();
        }
    },

    render: function(node) {
        this.form = this.$node.form;
        this.idx = 0;

        if (!this.form || !this.form.dmxExtraData) {
            console.warn('Filedrop can only work on a serverconnect form!');
            return;
        }

        this.message = document.createElement('div');
        this.message.className = 'dmxDropzoneMessage';
        this.message.innerHTML = this.props.message;

        this.dropzone = document.createElement('div');
        this.dropzone.style.cssText = this.$node.style.cssText;
        this.dropzone.className = this.$node.className;
        this.dropzone.classList.add('dmxDropzone');
        this.dropzone.appendChild(this.message);

        this.dropzone.addEventListener('click', this.click.bind(this));

        this.dropzone.addEventListener('dragover', this.dragover.bind(this));
        this.dropzone.addEventListener('dragenter', this.dragenter.bind(this));
        this.dropzone.addEventListener('dragleave', this.dragleave.bind(this));
        this.dropzone.addEventListener('drop', this.drop.bind(this));

        this.$node.addEventListener('change', this.change.bind(this));

        this.form.addEventListener('reset', this.reset.bind(this));

        dmx.dom.replace(this.$node, this.dropzone);
    },

    update: function(props) {
        var message = this.props.message;

        if (this.data.files.length) {
            message += ' (' + this.data.files.length + ' files)';
        } else if (this.data.file) {
            message += ' (' + this.data.file.name + ')';
        }

        if (this.message && this.message.innerHTML != message) {
            this.message.innerHTML = message;
        }
    },

    click: function(event) {
        this.$node.click();
    },

    change: function(event) {
        console.log('CHANGE', event, this);
        this.addFiles(event.target.files);
    },

    dragover: function(event) {
        // prevent default to allow drop
        event.preventDefault();
        event.stopPropagation();

        var ea;
        try { ea = event.dataTransfer.effectAllowed; } catch(e) {}

        event.dataTransfer.dropEffect = (ea == 'move' || ea == 'linkMove') ? 'move' : 'copy';
    },

    dragenter: function(event) {
        event.preventDefault();
        event.stopPropagation();
        this.dropzone.classList.add('dmxDropzoneHover');
    },

    dragleave: function(event) {
        this.dropzone.classList.remove('dmxDropzoneHover');
    },

    drop: function(event) {
        event.preventDefault();
        event.stopPropagation();
        this.dropzone.classList.remove('dmxDropzoneHover');

        if (!event.dataTransfer) return;

        var files = event.dataTransfer.files;

        if (files.length) {
            var items = event.dataTransfer.items;

            if (items && items.length && items[0].webkitGetAsEntry) {
                this.addFilesFromItems(items);
            } else {
                this.addFiles(files);
            }
        }
    },

    validate: function(file) {
        if (!this.props.accept) return true;
        return this.props.accept.split(/\s*,\s*/g).some(function(type) {
            if (type.charAt(0) == '.') {
                if (file.name.match(new RegExp('\\' + type + '$', 'i'))) {
                    return true;
                }
            } else if (/(audio|video|image)\/\*/i.test(type)) {
                if (file.type.match(new RegExp('^' + type.replace(/\*/g, '.*') + '$', 'i'))) {
                    return true;
                }
            } else {
                if (file.type.toLowerCase() == type.toLowerCase()) {
                    return true;
                }
            }
            return false;
        });
    },

    reset: function() {
        if (Array.isArray(this.form.dmxExtraData[this.$node.name])) {
            this.form.dmxExtraData[this.$node.name].forEach(function(file) {
                if (file.thumb) file.thumb.remove();
            });
        } else if (this.form.dmxExtraData[this.$node.name].thumb) {
            this.form.dmxExtraData[this.$node.name].thumb.remove();
        }

        this.form.dmxExtraData[this.$node.name] = null;
        this.set('files', []);
        this.set('file', null);
    },

    remove: function(id, event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        if (this.$node.multiple) {
            var index = this.data.files.findIndex(function(info) {
                return info.id == id;
            });

            if (index != -1) {
                this.data.files.splice(index, 1);
                this.form.dmxExtraData[this.$node.name][index].thumb.remove();
                this.form.dmxExtraData[this.$node.name].splice(index, 1);
                dmx.requestUpdate();
            }
        } else if (this.data.file) {
            this.data.file = null;
            this.form.dmxExtraData[this.$node.name].thumb.remove();
            this.form.dmxExtraData[this.$node.name] = null;
            dmx.requestUpdate();
        }
    },

    createThumb: function(file) {
        var thumb = document.createElement('div');
        thumb.className = 'dmxDropzoneThumb';
        thumb.title = file.name;
        thumb.style.setProperty('width', (parseInt(this.props['thumb-width']) || 100) + 'px');
        thumb.style.setProperty('height', (parseInt(this.props['thumb-height']) || 100) + 'px');
        thumb.addEventListener('click', this.remove.bind(this, file.id));

        var filename = document.createElement('div');
        filename.className = 'dmxDropzoneFilename';
        filename.textContent = file.name;
        thumb.appendChild(filename);

        var filesize = document.createElement('div');
        filesize.className = 'dmxDropzoneFilesize';
        filesize.textContent = this.formatSize(file.size);
        thumb.appendChild(filesize);

        file.thumb = thumb;

        this.dropzone.appendChild(thumb);
    },

    formatSize: function(number, decimals, binary) {
        if (isNaN(number) || !isFinite(number)) return 'Invalid Size';

        decimals = decimals || 1;

        var base = binary ? 1024 : 1000;
        var suffix = binary ? ['KiB', 'MiB', 'GiB', 'TiB'] : ['KB', 'MB', 'GB', 'TB'];

        for (var i = 3; i >= 0; i--) {
            var n = Math.pow(base, i + 1);
            if (number >= n) {
                number /= n;
                var pow = Math.pow(10, decimals);
                number = Math.round(number * pow) / pow;
                return number + suffix[i];
            }
        }

        return number + 'B';
    },

    resize: function(src, cb) {
        var img = document.createElement('img');

        var tWidth = parseInt(this.props['thumb-width']) || 100;
        var tHeight = parseInt(this.props['thumb-height']) || 100;

        img.onload = function() {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');

            var sWidth = img.width;
            var sHeight = img.height;

            tWidth = Math.min(tWidth, sWidth);
            tHeight = Math.min(tHeight, sHeight);

            var sRatio = sWidth / sHeight;
            var tRatio = tWidth / tHeight;

            if (sWidth > tWidth || sHeight > tHeight) {
                if (sRatio > tRatio) {
                    sWidth = sHeight * tRatio;
                } else {
                    sHeight = sWidth / tRatio;
                }
            }

            canvas.width = tWidth;
            canvas.height = tHeight;

            var sx = (img.width - sWidth) / 2;
            var sy = (img.height - sHeight) / 2;

            ctx.drawImage(img, sx, sy, sWidth, sHeight, 0, 0, tWidth, tHeight);

            cb(canvas.toDataURL());
        };
        img.src = src;
    },

    addFile: function(file) {
        if (!this.validate(file)) {
            console.info('Skipping ' + file.name + ', file not valid!');
            return;
        }

        if (this.$node.multiple) {
            this.form.dmxExtraData[this.$node.name] = this.form.dmxExtraData[this.$node.name] || [];
            this.form.dmxExtraData[this.$node.name].push(file);
        } else {
            this.remove();
            this.form.dmxExtraData[this.$node.name] = file;
        }

        file.id = ++this.idx

        var info = {
            id: file.id,
            date: (file.lastModified ? new Date(file.lastModified) : file.lastModifiedDate).toISOString(),
            name: file.name,
            size: file.size,
            type: file.type,
            dataUrl: null
        };

        if (this.props.thumbs != 'false') {
            this.createThumb(file);
        }

        if (file.type.indexOf('image/') !== -1 && !file.reader) {
            file.reader = new FileReader();

            file.reader.onload = function(event) {
                info.dataUrl = event.target.result;
                if (file.thumb) {
                    this.resize(info.dataUrl, function(dataUrl) {
                        file.thumb.style.setProperty('background-image', 'url(' + dataUrl + ')');
                    });
                }
                dmx.requestUpdate();
            }.bind(this);

            file.reader.readAsDataURL(file);
        }

        if (this.$node.multiple) {
            this.set('files', this.data.files.concat([info]));
        } else {
            this.set('file', info);
        }
    },

    addFiles: function(files) {
        dmx.array(files).forEach(function(file) {
            this.addFile(file);
        }, this);
    },

    addFilesFromItems: function(items) {
        dmx.array(items).forEach(function(item) {
            var entry;
            if (item.webkitGetAsEntry && (entry = item.webkitGetAsEntry())) {
                if (entry.isFile) {
                    this.addFile(item.getAsFile());
                } else if (entry.isDirectory) {
                    this.addFilesFromDirectory(entry);
                }
            } else if (item.getAsFile) {
                if (!item.kind || item.kind == 'file') {
                    this.addFile(item.getAsFile());
                }
            }
        }, this);
    },

    addFilesFromDirectory: function(directory, path) {
        var reader = directory.createReader();
        var readEntries = function() {
            reader.readEntries(function(entries) {
                if (entries.length) {
                    entries.forEach(function(entry) {
                        if (entry.isFile) {
                            entry.file(function(file) {
                                file.fullPath = path + '/' + file.name;
                                this.addFile(file);
                            }.bind(this));
                        } else if (entry.isDirectory) {
                            this.addFilesFromDirectory(entry, path + '/' + entry.name);
                        }
                    }, this);
                }

                readEntries();
            }.bind(this), function(error) {
                console.warn(error);
            }.bind(this));
        }.bind(this);

        readEntries();
    }

});
